import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminClientFeedbackPage from "@/pages/admin/AdminClientFeedbackPage";

export const Route = createFileRoute("/_admin/admin/client-feedback")({
  head: () => pageHead("Admin · Client Feedback", "AKIVA admin · client feedback portal.", "/admin/client-feedback", true),
  component: AdminClientFeedbackPage,
});
